import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { posServices } from "../../Services/pos.service";
import { useTranslation } from "react-i18next";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { tr } from "date-fns/locale";

import * as dateHelper from "../../Helpers/DateHelper";


const VersionHistoryTab = ({ posId }) => {
  const { isMobile, locPos, locTab } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const [versions, setVersions] = useState([]);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const [search, setSearch] = useState({
    storeId: locPos,
    searchText: "",
    sortName: "Name",
    isAsc: true,
  });
  const [update, setUpdate] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (locTab === "version") {
      posServices
        .getPosVersionHistory(
         posId
        )
        .then(res => {
          setIsLoading(false);
          setVersions(res.data.data);
          setPagination({ ...pagination, totalCount: res.data.totalCount });
        })
        .catch(err => {
          console.error(err.response);
        });
    }
  }, [update, searchText, locTab]);

  
  

 

  

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  function dateFormatter(cell, rows) {
      return dateHelper.formatUtcToDate(cell);
    }

  function actionHeaderFormatter(cell, rows) {
    return null;
  }

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="id"
        data={data}
        columns={columns}
       
        rowClasses="boostrap-table-row"
        noDataIndication={translator("No-Data")}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const columns = [
    {
      dataField: "id",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
     
      hidden: true,
    },
    {
      dataField: "version",
      text: translator("HistoryTab-TableHeader-Name"),
    },
    {
      dataField: "created",
      text: translator("HistoryTab-TableHeader-From"),
      hidden: Boolean(isMobile),
      formatter: dateFormatter,
    },
   
  ];

 

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0 ">
         

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={versions}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
             
            />
          )}
        </div>
      </div>

      
    </div>
  );
};

export default VersionHistoryTab;
